import React, { useState, useEffect } from "react"
import { storage } from "../../utils/firebase"
import S from "./styled"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faInfoCircle } from "@fortawesome/pro-light-svg-icons"

const Notes = () => {
  const [href, setHref] = useState("")

  useEffect(() => {
    const init = async () => {
      const ref = storage.ref("order-form.pdf")
      const url = await ref.getDownloadURL()
      setHref(url)
    }

    init()
  }, [])

  return (
    <S.Grid>
      <div>
        <h2>Notice: CD/DVD Media No Longer Supported</h2>
        <p>
          The Palm Beach County Bar Association CLE Library no longer
          distributes CLE materials on CD or DVD, as these media formats are no
          longer supported.
        </p>

        <p>
          All CLE content is now delivered as downloadable MP3 (audio) or MP4
          (video) files. This digital format eliminates shipping delays and
          allows reliable, easier access on most modern devices.
        </p>

        <p style={{ marginBottom: "7.5px" }}>
          <strong>Important Notes</strong>
        </p>

        <ul>
          <li>For best results, use a desktop or laptop computer.</li>
          <li>
            Check your device’s download folder or browser settings to find your
            files. On mobile devices, files usually appear in a Files or
            Downloads app.
          </li>
          <li>
            If you’ve recently updated your email address, allow up to 48 hours
            for changes to take effect.
          </li>
          <li>
            We are unable to assist with locating files on your device. Please
            contact your IT support if you need help.
          </li>
        </ul>

        <p style={{ marginBottom: "0" }}>
          <strong>
            If you experience issues logging in to our system to place an order,
            there may be a few reasons why:
          </strong>
          <ol>
            <li>
              Your email address does not match what we have in our database.
            </li>

            <li>
              You may not be in our database due to non-membership or unpaid
              dues.
            </li>

            <li>
              We may need to upload your email address and bar number into our
              CLE system. Therefore, you may need to reach out to us for
              additional assistance at{" "}
              <a href="mailto:info@palmbeachbar.org">info@palmbeachbar.org</a>{" "}
              or 561-687-2800 and ask for our Membership Coordinator.
            </li>
          </ol>
        </p>

        <p>
          If you have made a purchase and experienced a billing issue, please
          contact us at{" "}
          <a href="mailto:info@palmbeachbar.org">info@palmbeachbar.org</a> or
          561-687-2800 and ask for our Bookkeeper.
        </p>
      </div>

      <div className="right">
        <div>
          <div className="icon-container">
            <FontAwesomeIcon icon={faInfoCircle} size="2x" />
          </div>

          <div>
            <p className="hdg">How it Works</p>

            <ul>
              <li>
                <span>Log In</span>
                <br />
                Use your Florida Bar number to access the CLE library.
              </li>

              <li>
                <span>Select Courses</span>
                <br />
                Browse available CLE courses and add your selections to the
                shopping cart.
              </li>

              <li>
                <span>Purchase</span>
                <br />
                Complete the payment process to finalize your purchase.
              </li>

              <li>
                <span>Receive Download Links</span>
                <br />
                You will receive an email receipt with download links for your
                course materials.
              </li>

              <li>
                <span>Download Limits</span>
                <br />
                Each course purchase includes up to three (3) download attempts.
                Please avoid clicking links multiple times to prevent using all
                attempts.
              </li>

              <li>
                <span>Access Materials</span>
                <br />
                Download your CLE materials as MP3 (audio) or MP4 (video) files
                directly to your device.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </S.Grid>
  )
}

export default Notes
